import React from 'react';
import { Column } from 'rbx';

const ItemNameAndRemoveButton = ({ itemLink }) => (
  <Column.Group
    style={{
      backgroundColor: '#fbf8f8',
      borderBottom: '1px solid #b0b0b0',
    }}
  >
    <Column size={2}>
      {itemLink.name}&nbsp;<span style={{ fontWeight: 700 }}>+</span>
    </Column>
    <Column
      size={10}
      style={{ fontSize: '13px', cursor: 'pointer', color: '#EE2A7B' }}
    >
      <Column.Group>
        <Column size={2} />
        <Column size={2} />
        <Column size={2} />
        <Column size={2} />
        <Column size={2} />
        <Column size={2} />
      </Column.Group>
    </Column>
  </Column.Group>
);

export default ItemNameAndRemoveButton;
